/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ContextMenuTrigger
} from 'react-contextmenu';
import { connect } from 'react-redux';
import SharedTable from 'shared/ui/Table';
import debounce from 'lodash/debounce';
import { sortData } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectIsFetching, selectTemplatesSelected, vulnTemplatesList } from 'store/KnowledgeBase/selectors';
import { setFieldWidth } from 'store/Preferences/knowledgeBase/actions';
import knowledgeBaseSchema from './schema';
import { handleResizedChange } from './Functions';
import NoSearchResults from 'Common/Components/NoSearchResults';
import { selectFields } from 'store/Preferences/knowledgeBase/selectors';

class Table extends Component {
  constructor (props) {
    super(props);
    this.table = React.createRef();
    this.fetchData = this.fetchData.bind(this);
    this.isRowSelected = this.isRowSelected.bind(this);
    this.handleResizeColumn = debounce(this.handleResizeColumn.bind(this), 300);
  }

  componentWillUnmount () {
    this.handleResizeColumn.cancel();
  }

  handleResizeColumn (newResized) {
    handleResizedChange(newResized, this.props.fields, this.props.setFieldWidth);
  }

  isRowSelected (rowInfo) {
    return this.props.templatesSelected.filter((x) => x.id === rowInfo.original.id).length > 0;
  }

  fetchData (sorted) {
    const {
      isFetching
    } = this.props;

    if (!isFetching) {
      this.props.sortData(sorted);
    }
  }

  render () {
    const {
      data,
      isFetching,
      fields
    } = this.props;

    return (
      <div className="h-100 w-100" ref={ (element) => { this.table = element; } }>
        <ContextMenuTrigger id="massive_update_kb_table" holdToDisplay={ 1000000 }>
          <SharedTable
            schema={ knowledgeBaseSchema }
            context={ { isFetching, fields } }
            data={ data }
            isLoading={ isFetching }
            page={ 1 }
            onFetch={ this.fetchData }
            isRowSelected={ this.isRowSelected }
            onResize={ this.handleResizeColumn }
            noDataText={ !isFetching && <NoSearchResults /> }
          />
        </ContextMenuTrigger>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: vulnTemplatesList(state),
  isFetching: selectIsFetching(state),
  templatesSelected: selectTemplatesSelected(state),
  fields: selectFields(state)
});

const mapDispatchToProps = (dispatch) => ({
  sortData: (sorting) => {
    dispatch(sortData(sorting));
  },
  setFieldWidth: (field, value) => {
    dispatch(setFieldWidth(field, value));
  }
});

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFetching: PropTypes.bool.isRequired,
  sortData: PropTypes.func.isRequired,
  setFieldWidth: PropTypes.func.isRequired,
  templatesSelected: PropTypes.arrayOf(PropTypes.object).isRequired,
  fields: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
